var installedModules = {};
var moduleToHandlerMapping = {
	37852: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_core_19_0_7_rxjs_7_8_2_zone_js_0_15_0_node_modules_angular_-1dbed2")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 30664))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	73486: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_pnpm_angular_common_19_0_7__angular_core_19_0_7_rxjs_7_8_2_node_modules_-2d9699")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 78668))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	80064: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_internal_operators_auditTime_-6b9e6f"), __webpack_require__.e("default-node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 26579))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	81556: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_internal_operators_auditTime_-6b9e6f"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 81145))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	76456: {
		getter: () => (__webpack_require__.e("default-node_modules_pnpm_angular_core_19_0_7_rxjs_7_8_2_zone_js_0_15_0_node_modules_angular_-0528d3").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 64069))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	69886: {
		getter: () => (__webpack_require__.e("default-node_modules_pnpm_angular_core_19_0_7_rxjs_7_8_2_zone_js_0_15_0_node_modules_angular_-1ea056").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/event-dispatch */ 26261))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/event-dispatch",
	},
	31792: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_common_19_0_7__angular_core_19_0_7_rxjs_7_8_2_node_modules_-851a2e")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 10139))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	61417: {
		getter: () => (__webpack_require__.e("default-node_modules_pnpm_angular_platform-browser_19_0_7__angular_animations_19_0_7__angular-cde3ab").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 48288))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	14267: {
		getter: () => (__webpack_require__.e("default-node_modules_pnpm_angular_animations_19_0_7__angular_core_19_0_7_node_modules_angular-531b89").then(() => (() => (__webpack_require__(/*! @angular/animations */ 97659))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	2115: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_forms_19_0_7__angular_common_19_0_7__angular_core_19_0_7__a-e5bbc6")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 74271))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	71703: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_ngx-translate_core_16_0_4__angular_common_19_0_7__angular_core_19_0-a6b0be")]).then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 61530))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.0.4",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-translate/core",
	},
	32854: {
		getter: () => (__webpack_require__.e("default-node_modules_pnpm_apollo-link-ws_1_0_20_graphql_16_11_0_subscriptions-transport-ws_0_-c8b0cc").then(() => (() => (__webpack_require__(/*! apollo-link-ws */ 96241))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "apollo-link-ws",
	},
	23258: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("default-node_modules_pnpm_primeuix_styled_0_3_2_node_modules_primeuix_styled_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_usestyle_primeng_usestyle"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/base */ 42599))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/base",
	},
	56100: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_pnpm_primeuix_styled_0_3_2_node_modules_primeuix_styled_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_config_primeng_config"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/basecomponent */ 2868))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/basecomponent",
	},
	90488: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_pnpm_primeng_19_0_10__angular_animations_19_0_7__angular_cdk_19_2_17__an-24c9e2")]).then(() => (() => (__webpack_require__(/*! primeng/api */ 58648))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/api",
	},
	36772: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_angledoubledown_primeng_icons_angledoub-777683"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons */ 71110))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons",
	},
	50162: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! primeng/utils */ 72191))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/utils",
	},
	95278: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! primeng/ripple */ 1402))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/ripple",
	},
	17340: {
		getter: () => (__webpack_require__.e("default-node_modules_pnpm_primeng_19_0_10__angular_animations_19_0_7__angular_cdk_19_2_17__an-a45598").then(() => (() => (__webpack_require__(/*! primeng/dom */ 67784))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/dom",
	},
	73554: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/usestyle */ 77464))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/usestyle",
	},
	23642: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_api_primeng_api"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/config */ 16310))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/config",
	},
	18006: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("default-node_modules_pnpm_primeng_19_0_10__angular_animations_19_0_7__angular_cdk_19_2_17__an-8d3da1")]).then(() => (() => (__webpack_require__(/*! primeng/badge */ 27841))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/badge",
	},
	30946: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/autofocus */ 11195))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/autofocus",
	},
	84348: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/baseicon */ 27835))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/baseicon",
	},
	42768: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubledown */ 21667))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledoubledown",
	},
	66646: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubleleft */ 38720))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledoubleleft",
	},
	84520: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubleright */ 10011))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledoubleright",
	},
	68858: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubleup */ 28052))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledoubleup",
	},
	22958: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledown */ 76260))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledown",
	},
	56288: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angleleft */ 44007))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angleleft",
	},
	23812: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angleright */ 33618))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angleright",
	},
	32468: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angleup */ 78303))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angleup",
	},
	86940: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowdownleft */ 79389))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowdownleft",
	},
	93372: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowdownright */ 27416))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowdownright",
	},
	40970: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowdown */ 88742))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowdown",
	},
	41244: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowleft */ 51769))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowleft",
	},
	23024: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowright */ 54060))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowright",
	},
	93340: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowup */ 81637))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowup",
	},
	98666: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/ban */ 34826))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/ban",
	},
	66844: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/bars */ 51245))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/bars",
	},
	21144: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/blank */ 94487))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/blank",
	},
	61932: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/calendar */ 66137))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/calendar",
	},
	83824: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/caretleft */ 44199))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/caretleft",
	},
	53368: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/caretright */ 90642))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/caretright",
	},
	87516: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/check */ 53589))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/check",
	},
	66066: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevrondown */ 91192))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevrondown",
	},
	61316: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevronleft */ 6523))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevronleft",
	},
	79020: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevronright */ 89214))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevronright",
	},
	94304: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevronup */ 8363))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevronup",
	},
	46770: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/exclamationtriangle */ 77258))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/exclamationtriangle",
	},
	30356: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/eyeslash */ 59373))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/eyeslash",
	},
	28178: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/eye */ 43278))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/eye",
	},
	92246: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/filterslash */ 45652))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/filterslash",
	},
	11372: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/filter */ 71901))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/filter",
	},
	14528: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/home */ 18890))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/home",
	},
	31920: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/infocircle */ 28807))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/infocircle",
	},
	54188: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/minus */ 89697))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/minus",
	},
	35020: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/pencil */ 9596))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/pencil",
	},
	78748: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/plus */ 90039))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/plus",
	},
	33070: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/refresh */ 36320))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/refresh",
	},
	85436: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/searchminus */ 52049))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/searchminus",
	},
	21360: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/searchplus */ 49383))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/searchplus",
	},
	21036: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/search */ 44955))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/search",
	},
	55338: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/sortalt */ 91256))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/sortalt",
	},
	19824: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/sortamountdown */ 10363))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/sortamountdown",
	},
	13292: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/sortamountupalt */ 75417))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/sortamountupalt",
	},
	98270: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/spinner */ 18226))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/spinner",
	},
	39628: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/starfill */ 40496))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/starfill",
	},
	98520: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/star */ 94039))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/star",
	},
	86114: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/thlarge */ 97820))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/thlarge",
	},
	66836: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/timescircle */ 155))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/timescircle",
	},
	1024: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/times */ 59315))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/times",
	},
	53092: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/trash */ 79679))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/trash",
	},
	34508: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/undo */ 29581))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/undo",
	},
	52060: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/upload */ 29472))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/upload",
	},
	84156: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/windowmaximize */ 24393))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/windowmaximize",
	},
	94216: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_eventbus_index_mjs-13ee81"), __webpack_require__.e("default-node_modules_pnpm_primeuix_utils_0_3_2_node_modules_primeuix_utils_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/windowminimize */ 58011))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/windowminimize",
	},
	58358: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-node_modules_pnpm_primeng_19_0_10__angular_animations_19_0_7__angular_cdk_19_2_17__an-759e2d")]).then(() => (() => (__webpack_require__(/*! primeng/tooltip */ 12161))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/tooltip",
	},
	18623: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_pnpm_angular_router_19_0_7__angular_common_19_0_7__angular_core_19_0_7__-b94851")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 24515))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		37852
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		73486
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		80064
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		81556
	],
	"default-node_modules_pnpm_angular_core_19_0_7_rxjs_7_8_2_zone_js_0_15_0_node_modules_angular_-1dbed2": [
		76456,
		69886
	],
	"default-node_modules_pnpm_angular_platform-browser_19_0_7__angular_animations_19_0_7__angular-cde3ab": [
		31792
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		61417
	],
	"default-webpack_sharing_consume_default_angular_animations_angular_animations": [
		14267
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		2115
	],
	"default-libs_core_src_index_ts": [
		71703,
		32854
	],
	"default-webpack_sharing_consume_default_primeng_base_primeng_base": [
		23258
	],
	"default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent": [
		56100
	],
	"default-webpack_sharing_consume_default_primeng_api_primeng_api": [
		90488
	],
	"default-webpack_sharing_consume_default_primeng_icons_primeng_icons": [
		36772
	],
	"default-webpack_sharing_consume_default_primeng_utils_primeng_utils": [
		50162
	],
	"default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple": [
		95278
	],
	"default-webpack_sharing_consume_default_primeng_dom_primeng_dom": [
		17340
	],
	"default-webpack_sharing_consume_default_primeng_usestyle_primeng_usestyle": [
		73554
	],
	"default-webpack_sharing_consume_default_primeng_config_primeng_config": [
		23642
	],
	"default-webpack_sharing_consume_default_primeng_badge_primeng_badge": [
		18006
	],
	"default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus": [
		30946
	],
	"default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon": [
		84348
	],
	"default-webpack_sharing_consume_default_primeng_icons_angledoubledown_primeng_icons_angledoub-777683": [
		42768,
		66646,
		84520,
		68858,
		22958,
		56288,
		23812,
		32468,
		86940,
		93372,
		40970,
		41244,
		23024,
		93340,
		98666,
		66844,
		21144,
		61932,
		83824,
		53368,
		87516,
		66066,
		61316,
		79020,
		94304,
		46770,
		30356,
		28178,
		92246,
		11372,
		14528,
		31920,
		54188,
		35020,
		78748,
		33070,
		85436,
		21360,
		21036,
		55338,
		19824,
		13292,
		98270,
		39628,
		98520,
		86114,
		66836,
		1024,
		53092,
		34508,
		52060,
		84156,
		94216
	],
	"default-webpack_sharing_consume_default_primeng_tooltip_primeng_tooltip": [
		58358
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		18623
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}